import {
  getDefaultCompetitionId,
  resolveCompetitionFilters,
  resolveSeasonFilters,
} from '@statsbomb/kitbag-global-football/state';
import { atom } from 'jotai';
import { unwrap } from 'jotai/utils';
import { competitionAverageFiltersAtom } from '@/atoms/filters/competitionAverage';
import { competitionsAtom } from '@/atoms/queries/competitions';
import { playerCyclesOrderedAtom } from '@/atoms/queries/players';
import { convertOptionsToValues } from '@/utils/array';
import { createOptionsAtom } from '@/utils/atoms/generic';
import { createUserScopedSeasonOptionsAtom } from '@/utils/atoms/userCycles';

// The competition-average selection is user-scoped: any competition the user has access to, with the
// player's own main competition as the preferred default.
const userCompetitionOptionsAtom = createOptionsAtom(competitionsAtom, 'name', 'competition_id', [
  'area_code',
  'is_360',
]);

const unwrappedUserCompetitionOptionsAtom = unwrap(userCompetitionOptionsAtom, prev => prev ?? []);

const defaultCompetitionIdAtom = atom(async get => getDefaultCompetitionId(await get(playerCyclesOrderedAtom)));

const unwrappedDefaultCompetitionIdAtom = unwrap(defaultCompetitionIdAtom, prev => prev ?? null);

const competitionAverageCompetitionFiltersAtom = atom(get =>
  resolveCompetitionFilters({
    selectedCompetitionIds: get(competitionAverageFiltersAtom).competitionIds,
    competitionOptions: get(unwrappedUserCompetitionOptionsAtom),
    defaultCompetitionId: get(unwrappedDefaultCompetitionIdAtom),
  }),
);

export const competitionAverageCompetitionIdsToFilterByAtom = atom(get =>
  convertOptionsToValues(get(competitionAverageCompetitionFiltersAtom).selectedCompetitions),
);

export const competitionAverageSelectedCompetitionsAtom = atom(
  get => get(competitionAverageCompetitionFiltersAtom).selectedCompetitions,
);

const playerCompetitionAverageSeasonOptionsAtom = createUserScopedSeasonOptionsAtom(
  competitionAverageCompetitionIdsToFilterByAtom,
);

export const unwrappedPlayerCompetitionAverageSeasonOptionsAtom = unwrap(
  playerCompetitionAverageSeasonOptionsAtom,
  prev => prev ?? [],
);

export const competitionAverageSelectedSeasonsAtom = atom(
  get =>
    resolveSeasonFilters({
      selectedSeasonIds: get(competitionAverageFiltersAtom).seasonIds,
      seasonOptions: get(unwrappedPlayerCompetitionAverageSeasonOptionsAtom),
      currentYear: new Date().getFullYear(),
    }).selectedSeasons,
);

export const competitionAverageSeasonIdsToFilterByAtom = atom(get => {
  const selectedSeasonIds = get(competitionAverageFiltersAtom).seasonIds;
  if (selectedSeasonIds) return selectedSeasonIds;
  return convertOptionsToValues(get(competitionAverageSelectedSeasonsAtom));
});
